import styled from 'styled-components';

export const LeftnavLink = styled.div`
      @media screen and (max-width:1024px) {
          position: absolute;
          width: 100%;
          top: 10px;   
      }
 
a.mobile-blog.nav-link {
    display: none;
    @media screen and (max-width:1024px) {
     display:block;
    }
}
.nav-link{
    position: relative;
}
.active.nav-link:before {
    background: #ffff;
    width: 100%;
    height: 2px;
    content: "";
    bottom: 4px;
    position: absolute;
     @media screen and (max-width:1024px) {
       display:none;
     }
    
}

@media screen and (max-width:1024px) {

        .navbar-collapse{
                position: absolute;
                width: 100%;
                 left: 0px;
                background-color: #01606F;
                top: 15%;
                 display: none;
                &.collapse{
                        position: absolute;
                        width: 100%;
                        left: 0px;
                        background-color: #01606F;
                       top: 15%;
                          display: none !important;
                        &.show{
                            position: absolute;
                            z-index: 9;
                            background-color: #01606F;
                            width: 100%;
                            left: 0px;
                            top: 15%;
                             display: flex !important;
                             height: 100vh; 
                             overflow-y: scroll;
                                .navbar-nav{
                                   padding: 0 0px 15px 15px;
                                          position: absolute;
                                          top: 31px;

                                }  
                        }
                }
        }
}




}


    .navbar-nav{
        column-gap: 25px;

        @media screen and (max-width:1200px){
            column-gap: 20px;
        }

        @media screen and (max-width:1024px) {
            flex-direction: column;
            padding-left: 18px;
            padding-bottom: 20px;
          
            padding-top: 20px;
             width: 100%;
            
            // position: absolute;
            // //    transform: translateY(-100%);
            
            &::-webkit-scrollbar {
                width: 1px;
              }
               
              &::-webkit-scrollbar-track {
                box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
              }
               
             &::-webkit-scrollbar-thumb {
                background-color: darkgrey;
                outline: 1px solid slategrey;
              }
        }
       .nav-link{  
            color: #FFFFFF; 
    @media screen and (max-width:1280px) {
        padding-right: 13px;
    }
    .navbar-nav{
        column-gap: 25px;
        .nav-link{
            color: #FFFFFF;
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            padding: 0; 
            border-bottom: 2px solid transparent;
            position: relative;
           
            &.active{
                border-color: #fff;
                &:before {
                    display:block;
                }
            }
           
            &:after{
                vertical-align: 0.100em;
            }
            
        }
    }

`;
export const WriteaReview = styled.div`

    .write-yellow-btn { 
        @media screen and (max-width:1440px) {
        padding: 7px 8px;
        white-space: nowrap;
    }
    @media screen and (max-width:767px) {
        padding: 7px 23px;
        white-space: nowrap;
    }
 }
  
`;

export const DropMenu = styled.div`
    padding-top: 2px;
       position: absolute;
`;
export const UserBtn = styled.div`
 
    .dropdown{
        padding-top: 2px;
        
        button{
            &.login-btn{
                font-family: "Jost", sans-serif;
                font-size: 16px;
                font-weight: 500;
                line-height: 24px;
                font-style: normal;
                display: flex;
                align-items: center;
                box-shadow: 3px 5px 20px #00000033;
                border: 2px solid #F9DC70;
                border-radius: 10px;
                column-gap: 5px;
                padding: 8px 11px;
                background: transparent;
                transition: all 0.5s;
                 @media screen and (max-width:1440px){
                       padding: 9px 8px !important;
                   }
                &:hover, &.show{
                    background: #F9DC70;
                    border-color: #F9DC70;
                    color: #333333;
                    transition: all 0.5s;
        
                    svg {
                        #profile-circle {
                            path{
                                stroke: #333333;
                                transition: all 0.5s;
        
                                &#Vector-3, &#Vector-4{
                                    fill: #333333;
                                    transition: all 0.5s;
                                }
                            }
                        }
                    }
                }
            }
        }
        button{
             padding: 4px 8px 5px 4px;
            background: #33A7AE;
            display: flex;
            align-items: center;
            column-gap: 8px;
            border-color: #33A7AE;

            &:focus{
               background: #33A7AE;
            }

            .user-icon{
                width: 34px;
                height: 34px;
                box-shadow: 3px 10px 20px #00000033;
                border-radius: 8px;
            }

            &::after{
                display: none;
            }
            &:hover{
                color: #fff;
            }
            .down-arrow-icon{
                margin-left: 13px;
            }
        }
        &:hover {
            .dropdown-menu {
                display: block;
                margin-top: 0px;
                   @media screen and (max-width:1440px){
                      left:-3px;
                  }
                   @media screen and (max-width:1366px){
                      left:-39px;
                  }
                 @media screen and (max-width:1199px){
                      left:-39px;
                  }
            }
        }

        .dropdown-menu {
            display: none;
            background: #FFFFFF;
            box-shadow: 0px 10px 30px #00000033;
            border-radius: 10px;
            padding: 15px 20px;
            

            .dropdown-item{
                padding: 0;
                color: #333333;
                font-family: "Jost", sans-serif;
                font-size: 16px;
                line-height: 26px;
                margin-bottom: 5px;
                background: transparent;

                &:last-child{
                    margin-bottom: 0;
                }
            }
        }
    }
`;



